<template>
    <div>
        <template v-if="viewPage == true">
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left mt-2"> Add New Campus/Branch </h1>
        </div>
        <div class="row normal-ib-space">
            <div class="col-md-12">
                <ul class="page-status collections-page-status align-left pt-0">
                    <li class="page-status-list done">
                        <span class="status-highlighter">1</span>
                        Branch Detail
                    </li>
                    <li class="page-status-list done">
                        <span class="status-highlighter">2</span>
                        Add Students
                    </li>
                    <li class="page-status-list active">
                        <span class="status-highlighter">3</span>
                        Confirmation Messgae
                    </li>
                </ul>
            </div>
        </div>
        <div class="content-box p-5">
            <div class="add-new-branch-content align-center">
                <img src="/images/confirmation-tick.png" alt="" />
                <p class="mt-3"> Branch "{{campusName}}" has been <br/> added Successfully </p>
                <div class="btns-holder mt-4">
                    <router-link to="/feeCampus" class="btn btn-primary"> Back to Branches </router-link>
                </div>
            </div>
        </div>
        </template>
        <template v-else-if="viewPage == null">
            <preLoader></preLoader>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                campusName : '',
                viewPage : null,
            }
        },
        methods: {
            getCampusDetailById() {
                axios.get('/api/getCampusDetailById/'+this.$route.params.id)
                .then(result => {
                    if(result.status == 200){
                        this.viewPage = result.data.viewPage;
                        this.campusName = result.data.name.name;
                    }else{
                        this.viewPage = false;
                    }
                })
            }
        },
        mounted(){
            this.getCampusDetailById();
        },
        created() {
        },
    }
</script>
